export default {
  name: 'registrOk',
  props: {
    msg: String
  }
}